module.exports = __webpack_public_path__ + "@/assets/img/sv.452d4e21.svg";